import React, { useEffect, useState } from 'react'
import { useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { Customer } from 'types/customers'
import { customerActionAtom } from '../atoms/customersAtoms'
import { useCreateCustomerFeeForm } from '../hooks/useCreateCustomerFeeForm'
import { CustomerFeeSetupStep } from '../types'
import {
  CustomerFeeSetupSteps,
  CustomerFeeSuccess,
  CustomerSelection,
  SetCustomerFee,
} from './CustomerFeeSetup'

export const SetCustomerFees = () => {
  const { t } = useTranslation()
  const [step, setStep] = useState<CustomerFeeSetupStep>(CustomerFeeSetupSteps.SELECT_CUSTOMER)
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null)
  const setCustomerAction = useSetAtom(customerActionAtom)

  const { formValues, errors, register, setValue } = useCreateCustomerFeeForm()

  useEffect(() => {
    if (selectedCustomer) {
      setValue('customerId', selectedCustomer.reference)
    }
  }, [selectedCustomer])

  useEffect(() => {
    if (step === CustomerFeeSetupSteps.SUCCESS) {
      setCustomerAction(prev => ({ ...prev, header: undefined }))
    } else {
      setCustomerAction(prev => ({ ...prev, header: t('customers.feeSetup.setCustomerFees') }))
    }
  }, [step, setCustomerAction])

  return (
    <Box width="full">
      {step === CustomerFeeSetupSteps.SELECT_CUSTOMER && (
        <CustomerSelection setStep={setStep} setSelectedCustomer={setSelectedCustomer} />
      )}
      {step === CustomerFeeSetupSteps.SET_FEE && selectedCustomer && (
        <SetCustomerFee
          customer={selectedCustomer}
          setStep={setStep}
          formValues={formValues}
          errors={errors}
          register={register}
          setValue={setValue}
        />
      )}
      {step === CustomerFeeSetupSteps.SUCCESS && selectedCustomer && (
        <CustomerFeeSuccess setStep={setStep} />
      )}
    </Box>
  )
}
